<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="系统登录名"
                prop="userName"
              >
                <a-input
                  v-model="queryParam.userName"
                  placeholder="请输入系统登录名"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="公司名称"
                prop="companyName"
              >
                <a-input
                  v-model="queryParam.companyName"
                  placeholder="请输入公司名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="公司地址"
                prop="companyAddress"
              >
                <a-input
                  v-model="queryParam.companyAddress"
                  placeholder="请输入公司地址"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="联系人"
                prop="nickName"
              >
                <a-input
                  v-model="queryParam.nickName"
                  placeholder="请输入联系人"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="电话"
                prop="phoneNumber"
              >
                <a-input
                  v-model="queryParam.phoneNumber"
                  placeholder="请输入电话"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <!--            <template v-if="advanced">-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="用户状态" prop="status">-->
            <!--                  <a-select placeholder="请选择用户状态" v-model="queryParam.status" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--            </template>-->
            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['system:user:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 修改密码抽屉 -->
      <reset-password ref="resetPassword" />
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <publicPage ref="public"></publicPage>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span
          slot="status"
          slot-scope="text, record"
        >
          <dict-tag
            :options="dict.type['sys_enable_disable']"
            :value="record.status"
          />
        </span>
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="pipelineCount"
          slot-scope="text, record"
        >
          <a @click="$refs.public.handleAdd(record.id, 1, 1)">
            {{ record.pipelineCount }}
          </a>
        </span>
        <span
          slot="deviceCount"
          slot-scope="text, record"
        >
          <a @click="$refs.public.handleAdd(record.id, 2, 1)">
            {{ record.deviceCount }}
          </a>
        </span>
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['system:user:edit']"
          >
            <a-icon type="edit" />修改
          </a>
          <a-divider
            type="vertical"
            v-hasPermi="['system:user:remove']"
          />
          <a
            @click="handleDelete(record)"
            v-hasPermi="['system:user:remove']"
          >
            <a-icon type="delete" />删除
          </a>
          <a-divider
            type="vertical"
            v-hasPermi="['system:user:resetPwd']"
          />
          <a
            @click="$refs.resetPassword.handleResetPwd(record)"
            v-hasPermi="['system:user:resetPwd']"
          >
            <a-icon type="redo" />重置密码
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, delUser } from '@/api/system/user'
import CreateForm from './modules/CreateForm'
import ResetPassword from '@/views/system/user/modules/ResetPassword'
import { tableMixin } from '@/store/table-mixin'
import publicPage from '../../public.vue'
import moment from 'moment'
export default {
  name: 'User',
  components: {
    CreateForm,
    ResetPassword,
    publicPage
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userType: '04',
        userName: null,
        phoneMobile: null,
        email: null,
        nickName: null,
        status: null,
        companyName: null,
        companyAddress: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '系统登录名',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '公司名称',
          dataIndex: 'companyName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '公司地址',
          dataIndex: 'companyAddress',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '联系人',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '电话',
          dataIndex: 'phoneNumber',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '管线数量',
          dataIndex: 'pipelineCount',
          scopedSlots: { customRender: 'pipelineCount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备数量',
          dataIndex: 'deviceCount',
          scopedSlots: { customRender: 'deviceCount' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '用户状态',
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        console.log(response, 'responseresponseresponse===');
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userType: '04',
        userName: null,
        phoneMobile: null,
        email: null,
        nickName: null,
        status: null,
        companyName: null,
        companyAddress: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const userIds = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中公司名称为【' + row.companyName + '】的数据',
        onOk () {
          return delUser(userIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.id = {}
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () { }
      })
    }
  }
}
</script>
